<template>
  <div class="container">
    <div class="border">
      <div class="bg">
        <img class="img" :src="portraitUrl" srcset="">
      </div>
    </div>
    <div class="time-limit">
      <span class="text">从业{{workingYears}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    portraitUrl: {
      type: String,
      default: '',
    },
    workingYears: {
      type: String,
      default: '',
    }
  },
}
</script>

<style lang="less" scoped>
.container{
  position: relative;
  width: 62.3vw;
}
.border {
	width: 60.933vw;
	height: 60.933vw;
  border: solid 0.361vw #f0f9ff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  .bg {
    width: 56.667vw;
    height: 56.667vw;
    background-image: url('./static/doc_header_bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    .img {
      border-radius: 50%;
      width: 52.933vw;
      height: 52.933vw;
      overflow: hidden;
      object-fit: cover;
    }
  }
}

.time-limit {
  position: absolute;
  top: -2PX;
  right: 7PX;
	width: 15.333vw;
	height: 15.333vw;
  border: solid 2PX rgba(255, 255, 255, 0.53);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
  .text {
    z-index: 3;
    text-align: center;
    font-size: 3.7vw;
    line-height: 4.2vw;
  }
}
.time-limit::before {
  position: absolute;
  display: block;
  content: '';
  background-image: linear-gradient(270deg, 
  #216af6 0%, 
  #214cdb 100%);
  width: 100%;
  height: 100%;
  opacity: 0.53;
  border-radius: 50%;
}
</style>
